import { defineStore } from 'pinia'
import axios from 'axios'

export const useLoginStore = defineStore('login',{
  state: () => {
    return {
      user_logged_in: null,
    }
  },
  actions: {
    getQueryToLogin() {
      let output = null

      const email = document.getElementById('user_login').value,
          password = document.getElementById('user_password').value,
          code = document.getElementById('code').value;
      if (email && password && code) {
        output = {
          email,
          password,
          code
        }
        this.user_logged_in = output
      }
      return output
    },
    async getToken() {
      await axios.get('/sanctum/csrf-cookie')
    },
    async autologin() {
      let output = false;
      const credentials = await this.getQueryToLogin()
      if (credentials) {
        await this.login(credentials).then(response => {
          output = response
        })
      }
      return output
    },
    async login(data = null) {
      if (data) {
        await this.getToken()
        await axios.post('/login', data)
        return true
      } else {
        return false
      }
    },
  },
  strict: false
})
